// ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/auth-context";
import { ClipLoader } from "react-spinners";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <ClipLoader size={40} color="#4f46e5" />
      </div>
    );
  }

  return user ? children : <Navigate to="/landing" replace />;
}